import { useEffect, useState } from "react"
import IconInput from "../../atoms/IconInput/IconInput"
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import searchIcon from '../../../assets/icons/search.svg'
import './TablaBitacoras.scss'
import x from '../../../assets/icons/x.svg'
import waring from '../../../assets/icons/warning.png'
import deleteIcon from '../../../assets/icons/delete.png'
import reloadIcon from '../../../assets/icons/time.png'
import checkIcon from '../../../assets/icons/palomita.png'
import notaIcon from '../../../assets/icons/nota.png'
import girarIcon from '../../../assets/icons/girar.png'
import time from '../../../assets/icons/time.png'
import useGetScreenSize from "../../../CustomHooks/useGetScreenSize";
import HoverText from "../../atoms/HoverText/HoverText";
import ModalRegistrarIncidente from "./ModalRegistrarIncidente";
import ModalCambioDeHorario from "./ModalCambioDeHorario";
import ModalCancelarServicio from "./ModalCancelarServicio";
import ModalDesconfirmarBitacora from "./ModalDesconfirmarBitacora";
import ModalCrearNota from "./ModalCrearNota";
import { convertirFormatoFecha, formateoBasico, isoAUtc } from "../../../utilities/formateos";
import { Tooltip } from "@mui/material";
import useGetDataUser from "../../../CustomHooks/useGetDataUser";
import ModalTransferir from "./ModalTransferir";
const TablaBitacoras = ({
    data,
    setActualizar,
    actualizar,
    reloadBitacoras
}) => {
    const dataUser = useGetDataUser();
    const [showCrearNota, setShowCrearNota] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [showCrearIncidente, setShowCrearIncidente] = useState(false);
    const [showCambiarHora, setShowCambiarHora] = useState(false);
    const [showCancelarServicio, setShowCancelarServicio] = useState(false);
    const [showDesconfirmarBitacora, setShowDesconfirmarBitacora] = useState(false);
    const [showTransferir, setShowTransferir] = useState(false);
    const sizeScreen = useGetScreenSize()

    console.log("showTransferir", showTransferir);

    useEffect(() => {

        setActualizar(showCancelarServicio)

    }, [showCancelarServicio])

    const bodyStatus = (rowData) => {

        return (

            <>
                <td data-label="Status">
                    <Tooltip title={sizeScreen.width > 950 ? rowData.COMENTARIOS : ""}>
                        <div>
                            {
                                rowData.ESTATUS == 'Cancelado' ?
                                    <>
                                        <div className="status" style={{ background: "var(--red1)" }}>{rowData.ESTATUS}</div>
                                    </>
                                    :
                                    rowData.ESTATUS == 'Exepción' ?
                                        <>
                                            <div className="status" style={{ background: "var(--orange4)" }}>{rowData.ESTATUS}</div>
                                        </> :
                                        rowData.ESTATUS == 'Transferido' ?
                                            <>
                                                <div className="status">{rowData.ESTATUS}</div>
                                            </> : ""


                            }
                        </div>
                    </Tooltip>
                </td>
            </>
        )
    }
    const bodyRuta = (rowData) => {
        return (
            <td data-label="Ruta">
                <div className="rutaContainer">
                    <div className="rutaPoint">
                        <div className="point"></div>
                        <div className="ruta">{rowData.RUTA}</div>
                        {/* <div htmlFor=""> - {rowData.TURNO}</div> */}
                    </div>

                    <div className="nombre">{rowData.OPERADOR}</div>
                    <div className="turno"><b>Tipo: </b><div className="tipo">{rowData.TIPO}</div></div>
                </div>
            </td>

        )
    }
    const bodyFecha = (rowData) => {
        return (
            <td data-label="Fecha" className="tdPersonalizado">
                <div data-label="Fecha" className="fechaContainer">
                    <div className="fecha"> {isoAUtc(rowData.FECHA)}</div>
                    <div className="hora"> {rowData.HORA_ARRANQUE + " a " + rowData.HORA_LLEGADA}</div>
                </div>
            </td>
        )
    }
    const bodyTipo = (rowData) => {
        return (
            <td data-label="Unidad"><div className="unidadContainer">
                <div className="unidad"> {rowData.ID_UNIDAD != -1 ? 'U - ' + rowData.ID_UNIDAD : 'ALIADO'}</div>
            </div></td>

        )
    }
    const bodyAcciones = (rowData) => {
        
        const esMayor = (fecha, horaArranque) => {
            const [anio, mes, dia] = fecha.substring(0, 10).split('-').map(Number);
            const [horas, minutos] = horaArranque.split(':').map(Number);
            const fechaArranque = new Date(anio, mes - 1, dia, horas, minutos, 0, 0);
            const umbral = new Date(fechaArranque.getTime() - 40 * 60 * 1000);
            return new Date() < umbral;
        };
        
        return (
            <td data-label="Acciones">

                <div className="accionesContainer">
                    <Tooltip alignText="right" title={sizeScreen.width > 950 ? "Agregar Nota" : ""}>
                        <div className="containerNota">
                            {
                                !rowData.NOTAS ?
                                    <div></div>
                                    :
                                    <div className="puntoRojo"></div>
                            }
                            <img onClick={() => { setShowCrearNota({ id_bitacora: rowData.ID_TR_BITACORA }) }} className="warning" src={notaIcon}></img>
                        </div>
                    </Tooltip>
                    {rowData.ACCIONES.includes("1") ?
                        <Tooltip alignText="right" title={sizeScreen.width > 950 ? "Agregar incidente" : ""}>
                            <div>
                                <img onClick={() => { setShowCrearIncidente({ fecha: rowData.FECHA, id_unidad: rowData.ID_UNIDAD, bitacora: rowData.ID_TR_BITACORA, ruta: rowData.RUTA, nombre: rowData.OPERADOR, turno: "" }) }} className="warning" src={waring}></img>
                            </div>
                        </Tooltip> : ""}

                    {rowData.ACCIONES.includes("2") && esMayor(rowData.FECHA, rowData.HORA_ARRANQUE) && (
                        <Tooltip alignText="right" title={sizeScreen.width > 950 ? "Ver cambio de horario" : ""}>
                            <img onClick={() => { setShowCambiarHora({ bitacora: rowData.ID_TR_BITACORA, ruta: rowData.RUTA, turno: rowData.NOMBRE_TURNO, tiempoInicio: rowData.HORA_ARRANQUE, tiempoFin: rowData.HORA_LLEGADA }) }} src={time}></img>
                        </Tooltip>)}
                    {rowData.ACCIONES.includes("3") ?
                        <Tooltip alignText="right" title={sizeScreen.width > 950 ? "Cancelar servicios" : ""}>
                            <img onClick={() => { setShowCancelarServicio({ id_chofer: rowData.ID_CHOFER, id_unidad: rowData.ID_UNIDAD, bitacora: rowData.ID_TR_BITACORA, ruta: rowData.RUTA, nombre: rowData.OPERADOR, turno: '' }) }} src={deleteIcon} ></img>
                        </Tooltip> : ""}
                    {rowData.ACCIONES.includes("4") && rowData.CONFIRMADA ?
                        <Tooltip alignText="right" title={sizeScreen.width > 950 ? "Desconfirmar bitacora" : ""}>
                            <img onClick={() => { setShowDesconfirmarBitacora({ bitacora: rowData.ID_TR_BITACORA, ruta: rowData.RUTA, nombre: rowData.OPERADOR, turno: '' }) }} src={reloadIcon} ></img>
                        </Tooltip> : ""}
                    {rowData.ACCIONES.includes("5") && rowData.ID_RUTA == 13 ?
                        <Tooltip alignText="right" title={sizeScreen.width > 950 ? "Transferir" : ""}>
                            <img onClick={() => { setShowTransferir({ bitacora: rowData.ID_TR_BITACORA, ruta: rowData.RUTA, nombre: rowData.OPERADOR, fecha: rowData.FECHA, hora_banderazo: rowData.HORA_BANDERAZO, hora_arranque: rowData.HORA_ARRANQUE, hora_llegada: rowData.HORA_LLEGADA }) }} src={girarIcon} ></img>
                        </Tooltip> : ""}
                </div>
            </td>

        )
    }
    const bodyC = (rowData) => {
        return (
            <>
                {
                    rowData.CONFIRMADA ?
                        <>
                            <td data-label="C"><label><img src={checkIcon} width={"22px"} /></label></td>
                        </>
                        :
                        <>
                            <td data-label="C"><img src={x} width={"30px"} /></td>
                        </>
                }
            </>

        )
    }
    const bodyT = (rowData) => {
        return (
            <>
                {
                    rowData.TERMINADO ?
                        <>
                            <td data-label="T"><img src={checkIcon} width={"22px"} /></td>
                        </>
                        :
                        <>
                            <td data-label="T"><img src={x} width={"30px"} /></td>
                        </>
                }
            </>

        )
    }

    return (
        <div className="TablaBitacoras">
            {
                data.length > 0 ?
                    <>
                        <IconInput
                            type="search"
                            className='inputSearc'
                            onChange={(e) => setGlobalFilter(e.target.value)}
                            placeholder="Buscar..."
                            icon={searchIcon}
                        />
                        <DataTable
                            value={data}
                            globalFilter={globalFilter}

                        >
                            <Column field="status" header="Status" body={bodyStatus} />
                            <Column field="bitacora" header="ID" body={(rowData) => <td data-label="id">{rowData.ID_TR_BITACORA}</td>} />
                            <Column field="fecha" header="Fecha" body={bodyFecha} />
                            <Column field="AFOROS" header="Aforo" />
                            <Column field="ruta" header="Ruta" body={bodyRuta} />
                            <Column field="unidad" header="Unidad" body={bodyTipo} />
                            <Column field="c" header="Confirmado" body={bodyC} />
                            <Column field="t" header="Terminado" body={bodyT} />
                            <Column field="acciones" header="Acciones" body={bodyAcciones} />
                        </DataTable>
                    </> : ""
            }

            {showCrearIncidente ? <ModalRegistrarIncidente data={showCrearIncidente} setShowCrearIncidente={setShowCrearIncidente} /> : ""}
            {showCambiarHora ? <ModalCambioDeHorario data={showCambiarHora} setShowCambiarHora={setShowCambiarHora} /> : ""}
            {showCancelarServicio ? <ModalCancelarServicio data={showCancelarServicio} setShowCancelarServicio={setShowCancelarServicio} /> : ""}
            {showDesconfirmarBitacora ? <ModalDesconfirmarBitacora data={showDesconfirmarBitacora} setShowDesconfirmarBitacora={setShowDesconfirmarBitacora} /> : ""}
            {showCrearNota ? <ModalCrearNota data={showCrearNota} setShowCrearNota={setShowCrearNota} visible={showCrearNota ? true : false} /> : ""}
            {showTransferir ? <ModalTransferir
                reloadBitacoras={reloadBitacoras}
                actualizar={actualizar} setActualizar={setActualizar} visible={showTransferir ? true : false} data={showTransferir} onHide={() => setShowTransferir(false)} /> : ""}
        </div>
    )
}
export default TablaBitacoras